import axios from '../utils/axios';

// 获取所有复盘总结
export const getAllSummaries = () => {
  return axios.get('/api/summary/list');
};

// 获取单个复盘总结
export const getSummary = (id) => {
  return axios.get(`/api/summary/detail?id=${id}`);
};

// 创建复盘总结
export const createSummary = (data) => {
  return axios.post('/api/summary/create', data);
};

// 更新复盘总结
export const updateSummary = (id, data) => {
  return axios.put(`/api/summary/update?id=${id}`, data);
};

// 删除复盘总结
export const deleteSummary = (id) => {
  return axios.delete(`/api/summary/delete?id=${id}`);
};